<template>
  <div>
    <form id="form_instrutores">
        <div class="row">
            <div class="col-sm-12">
                <h4>Dados Básicos</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <InputIconGroup typeInput="text" idInput="nome" iconInput="fa-info" labelInput="Nome">
                    &nbsp;
                </InputIconGroup>
            </div>
            <div class="col-md-6">
                <InputIconGroup typeInput="email" idInput="email" iconInput="fa-envelope-o"
                                labelInput="E-mail">
                    E-mail do instrutor.
                </InputIconGroup>
            </div>
            <div class="col-md-3">
                <InputIconGroup typeInput="text" idInput="cpf" iconInput="fa-info" labelInput="CPF"
                                :inputMask="['###.###.###-##']">
                    ###.###.###-##
                    &nbsp;
                </InputIconGroup>
            </div>
            <div class="col-md-3">
                <InputIconGroup typeInput="text" idInput="cnh" iconInput="fa-info" labelInput="CNH">
                    &nbsp;
                </InputIconGroup>
            </div>
            <div class="col-md-3">
                <DateIconGroup idInput="data_nascimento" iconInput="fa-calendar"
                               labelInput="Data de nascimento">
                    (AAAA-MM-DD)
                </DateIconGroup>
            </div>

            <div class="col-md-3">
                <InputIconGroup idInput="telefone" iconInput="fa-phone" labelInput="Telefone/Celular"
                                :inputMask="['(##) ####-####', '(##) # ####-####']">
                    (##) ####-#### | (##) # ####-####
                </InputIconGroup>
            </div>

            <div class="col-md-3">
                  <DateIconGroup idInput="vencimento_cnh" iconInput="fa-calendar"
                                labelInput="Vencimento da CNH">
                      (AAAA-MM-DD)
                  </DateIconGroup>
            </div>

            <div class="col-md-3">
                  <DateIconGroup idInput="vencimento_ci" iconInput="fa-calendar"
                                labelInput="Vencimento da CI">
                      (AAAA-MM-DD)
                  </DateIconGroup>
            </div>

            <div class="col-md-3">
                  <SelectIconGroup labelInput="Tipo de Instrutor" idInput="tipo" iconInput="fa-info"
                  :optionsInput="optionsInput" :optionSelected="optionSelected"></SelectIconGroup>
            </div>
            <div class="col-md-3">
              <SelectIconGroup iconInput="fa-id-card" idInput="id_categoria_cnh" labelInput="Categoria" :optionsInput="optionsInputCategoria"
                :optionsSelected="optionSelectedCategoria">

                </SelectIconGroup>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <h4>Endereço</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-md-2">
                <InputIconGroup @change="searchCep($event)" typeInput="text" idInput="cep" iconInput="fa-info"
                                labelInput="CEP" :inputMask="['########']">
                    <a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm"
                       target="_blank">Consulte o CEP por endereço</a>
                </InputIconGroup>
            </div>
            <div class="col-md-4">
                <InputIconGroup typeInput="text" idInput="logradouro" iconInput="fa-info"
                                labelInput="" inputDisabled="disabled">
                    Logradouro
                </InputIconGroup>
            </div>
            <div class="col-md-3">
                <InputIconGroup typeInput="text" idInput="bairro" iconInput="fa-info"
                                labelInput="" inputDisabled="disabled">
                  Bairro
                </InputIconGroup>
            </div>
            <div class="col-md-2">
                <InputIconGroup typeInput="text" idInput="cidade" iconInput="fa-info"
                                labelInput="" inputDisabled="disabled">
                  Cidade
                </InputIconGroup>
            </div>
            <div class="col-md-1">
                <InputIconGroup typeInput="text" idInput="uf" iconInput="fa-info" labelInput=""
                                inputDisabled="disabled">
                  UF
                </InputIconGroup>
            </div>
            <div class="col-md-2">
                <InputIconGroup typeInput="text" idInput="numero" iconInput="fa-info"
                                labelInput="Número">
                    &nbsp;
                </InputIconGroup>
            </div>
            <div class="col-md-10">
                <InputIconGroup typeInput="text" idInput="complemento" iconInput="fa-info"
                                labelInput="Complemento">
                    &nbsp;
                </InputIconGroup>
            </div>

        </div>
        <div class="row">
            <div class="col-md-12 text-center">
                <button class="btn btn-secondary" id="btn_limpar" type="reset">Limpar</button>&nbsp;&nbsp;
                <button class="btn btn-primary" id="btn_salvar" type="button" @click="salvaInformacoes">
                    Salvar
                </button>
            </div>
        </div>
    </form>
  </div>
</template>

<script>
import InstrutoresController from './InstrutoresController'
import InputIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputIconGroup'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import SelectIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/SelectIconGroup'


window._ = require('lodash')

export default {
  name: 'form-instrutor',
  components: {
    InputIconGroup,
    DateIconGroup,
    SelectIconGroup
  },
  data () {
    return {
      content: {
        load: true
      },
      urlCep: 'https://viacep.com.br/ws/',
      optionSelected: '',
      debouncedInput: '',
      optionsInput: [
        {id: '', value: 'Selecione um tipo'},
        {id: 'Instrutor', value: 'Instrutor de aulas práticas'},
        {id: 'Professor', value: 'Professor de aulas teóricas'}
      ],
      optionSelected: '',
      optionsInputCategoria: [{
          id: '',
          value: 'Selecione uma categoria'
      }],
      optionSelectedCategoria: '',
    }
  },
  mounted () {
    let self = this;
    if (this.$route.params.idInstrutor) {
      InstrutoresController.carregaFormularioDeEdicao(this.$route.params.idInstrutor)
    } else {
      InstrutoresController.getCategoria(function (data) {
          data.dados.map(function (value) {
              self.optionsInputCategoria.push({ id: value.id_categoria_cnh, value: value.categoria_cnh })
          })
      })
    }
  },
  methods: {
    salvaInformacoes () {
      if (this.$route.params.idInstrutor) {
        InstrutoresController.update(this.$route.params.idInstrutor)
      } else {
        InstrutoresController.store()
      }
    },
    loadData () {
      this.table.load = true
      this.$http.get(this.urlCep + this.search + '/json/').then(this.callbackDataPaginate)
    },
    searchCep (e) {
      InstrutoresController.searchCep(e)
    }
  }
}
</script>
